module.exports = __webpack_public_path__ + "static/media/play-boss-3.4066cd83.png";